require('./transfersMoreOptionsButton.scss');
const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const classNames = require('classnames');
// @commons
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKIconTask } = require('commonsComponents/OKIconTask');
// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { removeCurrentSectionOption } = require('utilities/moreOptionsHelper');

class TransfersMoreOptionsButton extends React.Component {
    buildMoreOptions () {
        const accountId = this.props.immAccount.get('accountId');

        let options = [
            {
                link: `/myprofile/transfers/received/${accountId}`,
                text: formatText('transfersMoreOptions-receivedTransfers')
            },
            {
                link: `/myprofile/transfers/emited/${accountId}`,
                text: formatText('transfersMoreOptions-emitedTransfers')
            },
            {
                link: `/myprofile/transfers/scheduled/${accountId}`,
                text: formatText('transfersMoreOptions-scheduledTranfers')
            },
            {
                link: `/myprofile/transfers/agenda`,
                text: formatText('transfersMoreOptions-beneficiariesAgenda')
            }
        ];

        return removeCurrentSectionOption(options);
    }

    render() {
        const contentClass = classNames('transfers-more-options-button', {
            'hidden-xs': this.props.hiddenOnMobile,
        });
        let content = (<div></div>);

        if (this.props.immAccount) {
            const moreOptions = this.buildMoreOptions();
            const targetElement = (
                <div>
                    <div className="hidden-xs">
                        <OKButton
                            modifier="ghost"
                            inverse={true}
                            rightIcon="icon-dropdown-abrir"
                            smallRightIcon={true}
                        >
                            <FormattedText value="transfers-moreOptions" />
                        </OKButton>
                    </div>
                    <div className="visible-xs">
                        <OKIconTask activeHover={false} icon="icon-s-op-comp" type="standalone" style="dark-bg" />
                    </div>
                </div>
            );
            content = (
                <PopoverMenu
                    target={targetElement}
                    items={moreOptions}
                    placement="bottomRight"
                />
            );
        }

        return <div className={contentClass}>{content}</div>;
    }
}

TransfersMoreOptionsButton.propTypes = {
    hiddenOnMobile: PropTypes.bool,
    immAccount: PropTypes.object.isRequired,
};

TransfersMoreOptionsButton.defaultProps = {
    hiddenOnMobile: false,
}

module.exports = TransfersMoreOptionsButton;